import '.g4{border-left:4px solid var(--gray-200);}.ssr-plugin'
import '.g5{padding-left:1.5rem;}.ssr-plugin'
import '.g6{margin:1rem 0;}.ssr-plugin'
import '.g7{color:var(--gray-700);}.ssr-plugin'
import '.g8{font-style:italic;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { PropsWithChildren } from 'react'

interface BlockQuoteProps extends PropsWithChildren {
  style?: Style
}

export const BlockQuote = ({ children, style }: BlockQuoteProps) => {
  return (
    <styled.blockquote className="g4 g5 g6 g7 g8"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.blockquote>
  )
}
